export default __webpack_public_path__ + "static/perfil-search-e3fdbba2d1fbd5f5e54656204b286a7e.png";